
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Нормы себестоимости', path: '/tms/standards' },
            { id: 2, name: 'Нормы загруженности', path: '/tms/standards/load-standards' },
        ]

        return { tabs }
    },
})
